// Loaders memoizados para librerías pesadas usadas por el flujo de generación
// de PDFs. Cada `get*` devuelve siempre la misma promesa: el módulo se descarga
// y prepara una sola vez por sesión, en lugar de en cada PDF.
//
// `warmupPdfLibs` precarga las tres en paralelo y se usa al principio de un
// batch para que el primer PDF no pague la latencia inicial.

let pdfMakePromise: Promise<any> | null = null;
let html2canvasPromise: Promise<any> | null = null;
let pdfLibPromise: Promise<typeof import("pdf-lib")> | null = null;

export function getPdfMake(): Promise<any> {
  if (!pdfMakePromise) {
    pdfMakePromise = (async () => {
      const [m, f] = await Promise.all([
        import("pdfmake/build/pdfmake"),
        import("pdfmake/build/vfs_fonts"),
      ]);
      const pdfMake = (m as any).default;
      pdfMake.vfs = (f as any).default;
      return pdfMake;
    })();
  }
  return pdfMakePromise;
}

export function getHtml2canvas(): Promise<any> {
  if (!html2canvasPromise) {
    html2canvasPromise = import("html2canvas").then((m) => m.default);
  }
  return html2canvasPromise;
}

export function getPdfLib(): Promise<typeof import("pdf-lib")> {
  if (!pdfLibPromise) {
    pdfLibPromise = import("pdf-lib");
  }
  return pdfLibPromise;
}

export function warmupPdfLibs(): void {
  getPdfMake();
  getHtml2canvas();
  getPdfLib();
}
